export class Type {
  name: string;

  constructor(datas?) {
    Object.assign(this, datas);
  }
}
